import { z } from 'zod';
import type { TableEditItem } from '@/components/table/table-edit/types';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { ClienteFiscalPerfil } from '@/features/cliente/types/enum';
import { DestinoNotaFiscal } from '@/features/fiscal/enum/DestinoNotaFiscal';
import { DevolucaoOperacao } from '@/features/fiscal/enum/DevolucaoOperacao';
import { TipoCliente } from '@/features/fiscal/enum/TipoCliente';
import { NotaFiscalTipo } from '@/features/nfe/types/enum';

export const RegraFiscalIpiSchema = z.object({
    rip_aliquota_ipi: z.number().nullable(),
    rip_classe_enquadramento: z.string().nullable(),
    rip_cnpj_produtor: z.string().nullable(),
    rip_cst_ipi: z.string().nullable(),
    rip_destino: z.enum(DestinoNotaFiscal).nullable(),
    rip_devolucao_operacao: z.enum(DevolucaoOperacao).nullable(),
    rip_empresa_idpk: z.number(),
    rip_estado_especifico: z.string().nullable(),
    rip_extipi: z.string().nullable(),
    rip_idpk: z.number(),
    rip_motivo: z.number().nullable(),
    rip_perfil_cliente: z.enum(ClienteFiscalPerfil),
    rip_regra_fiscal_idpk: z.number(),
    rip_selo_codigo: z.string().nullable(),
    rip_selo_quantidade: z.number().nullable(),
    rip_somar_bc_icms: z.enum(['S', 'N']),
    rip_tipo: z.enum(NotaFiscalTipo).nullable(),
    rip_tipo_cliente: z.enum(TipoCliente).nullable(),
    rip_tipo_tributacao: z.number().nullable(),
    rip_todos_estados: z
        .enum(['S', 'N', ''])
        .nullable()
        .transform((v) => (v === '' ? null : v)),
    rip_valor_ipi: z.number().nullable(),
});

type RegraFiscalIpi = z.infer<typeof RegraFiscalIpiSchema>;

export type RegraFiscalIpiBody = PartialUndefinedOrNull<RegraFiscalIpi> & TableEditItem;
